function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Growth",
  transform: "translate(-2580.83 -1055.942)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_604",
  "data-name": "Trazado 604",
  d: "M2684.6,1332.742l-2.755,17.878-.209,1.391-.25,1.6a1.4,1.4,0,0,1-1.378,1.183h-24.181a1.4,1.4,0,0,1-1.377-1.183l-.25-1.6-.209-1.391-2.755-17.878a1.393,1.393,0,0,1,1.377-1.6h30.609a1.394,1.394,0,0,1,1.393,1.395A1.444,1.444,0,0,1,2684.6,1332.742Z",
  transform: "translate(-55.09 -215.374)",
  fill: "#004384"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_605",
  "data-name": "Trazado 605",
  d: "M2684.518,1333.257l-2.963-2.115h-28.939a1.394,1.394,0,0,0-1.393,1.395,1.444,1.444,0,0,0,.015.205c3.124,20.274,2.685,17.415,2.963,19.27l.25,1.6a1.4,1.4,0,0,0,1.377,1.183h1.864l-.334-2.783h24.278l.209-1.391h-24.64l-1.809-15.3h28.814Z",
  transform: "translate(-55.09 -215.374)",
  fill: "#01003a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_606",
  "data-name": "Trazado 606",
  d: "M2744.462,1242.12a1.389,1.389,0,0,0-1.128-.578H2741a13.583,13.583,0,0,0-12.9,9.3,1.393,1.393,0,0,0,1.32,1.832h2.331a13.583,13.583,0,0,0,12.9-9.3,1.392,1.392,0,0,0-.192-1.254Z",
  transform: "translate(-115.199 -145.252)",
  fill: "#004384"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_607",
  "data-name": "Trazado 607",
  d: "M2667.855,1250.841a13.583,13.583,0,0,0-12.9-9.3h-2.331a1.392,1.392,0,0,0-1.32,1.832,13.583,13.583,0,0,0,12.9,9.3h2.331a1.392,1.392,0,0,0,1.32-1.832Z",
  transform: "translate(-55.096 -145.252)",
  fill: "#004384"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_608",
  "data-name": "Trazado 608",
  d: "M2723.021,1243.212a1.392,1.392,0,0,1-1.391-1.391v-18.087a1.391,1.391,0,0,1,2.783,0v18.087A1.392,1.392,0,0,1,2723.021,1243.212Z",
  transform: "translate(-110.191 -130.226)",
  fill: "#4292ff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_29",
  "data-name": "Elipse 29",
  cx: 19.478,
  cy: 19.478,
  r: 19.478,
  transform: "translate(2593.352 1055.942)",
  fill: "#4292ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_609",
  "data-name": "Trazado 609",
  d: "M2661.055,1100.071c-7.332-4.981-14.066-13.12-13.621-26.143a37.8,37.8,0,0,1,.612-5.635,19.471,19.471,0,0,0,9.851,36.271,19.129,19.129,0,0,0,7.93-1.7A43.819,43.819,0,0,1,2661.055,1100.071Z",
  transform: "translate(-45.066 -9.667)",
  fill: "#275ed6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_30",
  "data-name": "Elipse 30",
  cx: 15.304,
  cy: 15.304,
  r: 15.304,
  transform: "translate(2597.526 1060.116)",
  fill: "#69abf9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_610",
  "data-name": "Trazado 610",
  d: "M2793.8,1332.742l-.083.515-2.963-2.115h1.669a1.394,1.394,0,0,1,1.393,1.395A1.409,1.409,0,0,1,2793.8,1332.742Z",
  transform: "translate(-164.285 -215.374)",
  fill: "#004384"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_611",
  "data-name": "Trazado 611",
  d: "M2685.995,1369.158a1.392,1.392,0,0,1-1.375-1.194l-1.391-9.739a1.391,1.391,0,1,1,2.746-.452c0,.019.006.038.008.058l1.391,9.739a1.393,1.393,0,0,1-1.184,1.574,1.355,1.355,0,0,1-.2.014Z",
  transform: "translate(-80.123 -235.303)",
  fill: "#01003a"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_391",
  "data-name": "Grupo 391",
  transform: "translate(2580.83 1067.072)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_612",
  "data-name": "Trazado 612",
  d: "M2715.783,1114.1a1.391,1.391,0,0,0,1.391-1.391v-.2a3.963,3.963,0,0,0-2.783-3.769v-.2a1.391,1.391,0,0,0-2.783,0v.2a3.957,3.957,0,0,0-.587,7.321l2.713,1.355a1.189,1.189,0,0,1-.531,2.252h-.406a1.19,1.19,0,0,1-1.188-1.188v-.2a1.391,1.391,0,1,0-2.782,0v.2a3.963,3.963,0,0,0,2.782,3.769v.2a1.391,1.391,0,1,0,2.783,0v-.2a3.956,3.956,0,0,0,.588-7.321l-2.713-1.355a1.188,1.188,0,0,1,.531-2.252h.406a1.19,1.19,0,0,1,1.188,1.188v.2A1.391,1.391,0,0,0,2715.783,1114.1Z",
  transform: "translate(-2681 -1107.142)",
  fill: "#004384"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_952",
  "data-name": "Rect\\xE1ngulo 952",
  width: 38.957,
  height: 8.348,
  rx: 4.174,
  transform: "translate(12.522 43.13)",
  fill: "#004384"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_613",
  "data-name": "Trazado 613",
  d: "M2586.4,1429.925h-4.174a1.391,1.391,0,0,1,0-2.783h4.174a1.391,1.391,0,1,1,0,2.783Z",
  transform: "translate(-2580.83 -1357.577)",
  fill: "#004384"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_614",
  "data-name": "Trazado 614",
  d: "M2678.5,1429.925h-51.479a1.391,1.391,0,0,1,0-2.783H2678.5a1.391,1.391,0,1,1,0,2.783Z",
  transform: "translate(-2615.891 -1357.577)",
  fill: "#004384"
})), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_615",
  "data-name": "Trazado 615",
  d: "M2676.093,1120.357a15.692,15.692,0,0,1-3.158.32,15.3,15.3,0,0,1-10.463-26.463C2662.026,1107.237,2668.76,1115.376,2676.093,1120.357Z",
  transform: "translate(-60.104 -29.952)",
  fill: "#4292ff"
}));

var SvgEmptyIcon = function SvgEmptyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 83.478,
    viewBox: "0 0 64 83.478",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emptyIcon.536b512f.svg";
export { ForwardRef as ReactComponent };